import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { SpaceDiscriminator, useGetSpacesByIdQuery } from '@client/api';
import { useIsUsageType } from '@client/toolkit';

import { CommercialItemsCard } from '../../../../components/commercial-items-card/commercial-items-card';
import { CommonAreasListCard } from '../../../../components/common-areas-list-card/common-areas-list-card.component';
import { GroupItemsCard } from '../../../../components/group-items-card';
import { SpaceAreaHistoryCard } from '../components/space-area-history/space-area-history-card.component';
import { SpaceInformationCard } from '../components/space-information/space-information-card.component';

export const GenericView = () => {
  const { spaceId, discriminator } = useParams<{ spaceId: string; discriminator: SpaceDiscriminator }>();

  const { data: space, isFetching } = useGetSpacesByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  const building = useMemo(() => space?.building, [space?.building]);
  const { isCommercialOrMixed, isResidential } = useIsUsageType(building?.usageType);

  // Check if this is a Group (Generic space - all Generic spaces should use group-level data)
  const isGroup = discriminator === 'Generic';

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <SpaceInformationCard space={space} isFetching={isFetching} discriminator={discriminator} />

        <SpaceAreaHistoryCard spaceId={spaceId} />

        {isCommercialOrMixed && (isGroup ? <GroupItemsCard dense /> : <CommercialItemsCard dense />)}

        {(building?.usageType == null || isResidential) && <CommonAreasListCard />}
      </div>
    </div>
  );
};
